import React from "react";
import { Grid } from "@mui/material";
import comentariosForm from "../../assets/forms/Comentarios_Sobre_el_ELL_Assessment_Test.docx";
import candidatoFraudForm from "../../assets/forms/Comportamiento_Fraudulento_Candidato.docx";
import centroFraudForm from "../../assets/forms/Comportamiento_Fraudulento_Centro_de_Pruebas.docx";
import vigilantesForm from "../../assets/forms/Entrenamiento_a_Vigilantes.docx";
import incidentesForm from "../../assets/forms/Formato_de_Registro_de_incidentes.docx";
import asientosForm from "../../assets/forms/Plano_de_Asientos.docx";
import chequeoForm from "../../assets/forms/Protocolos_de_Chequeo.docx";
import asistenciaForm from "../../assets/forms/Registro_de_Asistencia.docx";

const FORM_DOWNLOADS = [
  {
    name: "Formato de Registro de incidentes",
    file: incidentesForm,
  },
  {
    name: "Comportamiento Fraudulento Centro de Pruebas",
    file: centroFraudForm,
  },
  {
    name: "Comportamiento Fraudulento Candidato",
    file: candidatoFraudForm,
  },
  {
    name: "Plano de Asientos",
    file: asientosForm,
  },
  {
    name: "Comentarios Sobre el ELL Assessment Test",
    file: comentariosForm,
  },
  {
    name: "Entrenamiento a Vigilantes",
    file: vigilantesForm,
  },
  {
    name: "Registro de Asistencia",
    file: asistenciaForm,
  },
  {
    name: "Protocolos de Chequeo",
    file: chequeoForm,
  },
];

function Forms() {
  return (
    <>
      <h1>Forms</h1>
      <h5>Choose the form you wish to download:</h5>
      <Grid container spacing={4}>
        {FORM_DOWNLOADS.map((form) => (
          <Grid item xs={4} key={form.name}>
            <div className="download-name-wrapper">
              <a href={form.file} download>
                {form.name}
              </a>
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default Forms;
